import { Box, Typography } from "@mui/material";
import { OLTabs } from "components/Tabs/OLTabs";
import { useMessage } from "hooks/intl";
import { useActiveTab } from "hooks/useActiveTab";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { AvailableRewards } from "./AvailableRewards";
import { RedeemedRewards } from "./RedeemedRewards";
import { useStyles } from "./SingleMember.styles";

export function Rewards() {
  const { message } = useMessage();
  const classes = useStyles();
  const { id: memberID } = useParams<{ id: string; page: string }>();

  const tabLabels = {
    availableRewards: "availableRewards",
    redeemedRewards: "redeemedRewards",
  } as const;
  const tabsList = Object.keys(tabLabels) as TabLabel[];
  type TabLabel = (typeof tabLabels)[keyof typeof tabLabels];
  const initialActiveTabState = tabLabels.availableRewards;
  const { activeTab, changeActiveTab } = useActiveTab({
    id: "memberRewards",
    tab: initialActiveTabState,
  });

  return (
    <>
      <Typography mb={6} className={classes.header}>
        {message({ id: "rewards" })}
      </Typography>
      <OLTabs
        items={tabsList}
        value={activeTab}
        onChange={(_: React.SyntheticEvent, newValue: TabLabel) =>
          changeActiveTab(
            links.singleMemberRewards(memberID as string),
            "memberRewards",
            newValue,
          )
        }
      />
      <Box mt={8} />
      {activeTab === tabLabels.availableRewards ? (
        <AvailableRewards memberID={memberID as string} />
      ) : activeTab === tabLabels.redeemedRewards ? (
        <RedeemedRewards memberID={memberID as string} />
      ) : null}
    </>
  );
}
